import { SectionWrapper } from '../components/SectionWrapper';

import styles from './ResearcherQuotesSection.module.css';

const quotes = [
  {
    attribution:
      'Lead author - Doctoral student, UCLA Department of Physics & Astronomy',
    name: 'Yifan Lu',
    quote:
      'By implementing scalable and low-cost interventions, we can create more equitable learning environments. Using AI tools can remove social barriers that prevent students from asking instructors, teaching assistants, and/or peers for help.',
  },
  {
    attribution:
      'Co-author - Executive Vice Chancellor and Distinguished Professor, UC San Diego',
    name: 'Elizabeth H. Simmons',
    quote:
      'Our findings demonstrate that thoughtful integration of technology and targeted incentives can make a meaningful difference in student academic performance. These strategies are effective and feasible for widespread adoption in a wide range of undergraduate courses that include mathematical topics.',
  },
];

export function ResearcherQuotesSection() {
  return (
    <SectionWrapper background="white" data-testid="research-section-quotes">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>IN THEIR WORDS</p>
          <h2 className={styles.title}>What the researchers said.</h2>
        </div>
        <div className={styles.cards}>
          {quotes.map((quote) => (
            <figure className={styles.card} key={quote.name}>
              <span aria-hidden="true" className={styles.mark}>
                &quot;
              </span>
              <blockquote>{quote.quote}</blockquote>
              <figcaption>
                <strong>{quote.name}</strong>
                <span>{quote.attribution}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
